module.exports = __webpack_public_path__ + "img/Group 13@2x.png";